<template>
  <div>
    <div class="lke-titl">
      <div>
        <i class="el-icon-caret-right"></i>
        当前位置：证书申请
      </div>
    </div>
    <div class="lke-mid">
      <div class="lke-mid-top">
        <i class="el-icon-s-order"></i>
        证书申请
      </div>
      <div class="lke-mid-fot">
        <div class="lke-tab1in">
          <div class="lke-tab1in-top">
            <i class="el-icon-star-on"></i>
            当您的课程学习完毕并通过后可申请相应的证书
          </div>
        </div>
        <div class="lke-tab1in">
          <div class="lke-tab1in-top">
            <i class="el-icon-star-on"></i>
            如果您有问题可以登录后在学员工作室中提问。会有相应的老师和学员回答您的问题。
          </div>
        </div>
      </div>
    </div>
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="证书列表" name="0">
        <el-table :data="list" fit style="width: 100%" v-loading="listLoading">
          <el-table-column prop="name" label="证书名称"> </el-table-column>
          <el-table-column label="操作" width="180">
            <template slot-scope="{ row }">
              <el-button
              v-if="row.state == -2"
                size="small"
                type="primary"
                @click="addnew_certificat(row._id)"
                >申请证书</el-button
              >
              <el-button
              v-else-if="row.state == -1"
                size="small"
                type="warning"
                @click="onaddnew_certificat(row)"
                >未通过，点击查看详情</el-button
              >
              <el-button
                v-else-if="row.state == 0 || row.state == 1"
                size="small"
                >审核中</el-button
              >
              <el-button
                v-else-if="row.state == 2"
                size="small"
                type="warning"
                @click="looknew_certificat(row.data._id)"
                >已通过,查看证书</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { getcertificate, addnew_certificat, getnew_certificat, deletenew_certificat } from "@/api/index";
export default {
  props: {},
  data() {
    return {
      activeName: "0",
      url: "@/pages/index/assets/bird.jpeg",
      list: [],
      listLoading: false,
      new_certificat: []
    };
  },
  computed: {},
  created() {
    this.getcertificate();
  },
  mounted() {},
  watch: {},
  methods: {
    
    getcertificate() {
      this.listLoading = true;
      getcertificate().then((response) => {
        getnew_certificat().then(data=>{
          this.new_certificat = data.result
          for (let index = 0; index < response.length; index++) {
          response[index].state = -2
          for (let i = 0; i < data.result.length; i++) {
            if (response[index]._id === data.result[i].certificateId) {
              response[index].state = data.result[i].state
              response[index].data = data.result[i]
            }
        }
          }
          
          this.listLoading = false;
        this.list = response;
        }) 
      });
    },

    looknew_certificat(val) {
      this.$router.push({
            name: "zsxq",
            params: {
              id: val,
            },
          });
    },

    onaddnew_certificat(val) {
      this.$confirm('拒接理由:' + val.data.applyState, '提示', {
          confirmButtonText: '重新申请',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deletenew_certificat(val.data._id).then(()=>{
            this.addnew_certificat(val._id)
          })
        }).catch(() => {       
        });
    },

    addnew_certificat(val) {
      this.listLoading = true;
      const obj = {
        certificateId: val
      }
      addnew_certificat(obj).then((response) => {
        this.getcertificate()
      }).catch(()=>{
        this.listLoading = false;
      });
    },
  },
  components: {},
};
</script>

<style>
</style>

<style scoped>
::v-deep.el-tabs__item {
  font-size: 18px !important;
  letter-spacing: 1px;
}
::v-deep.el-tabs__item.is-active {
  font-weight: 600;
}
.lke-titl {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  padding-bottom: 20px;
}
.lke-titl > div:first-child {
  display: flex;
  align-items: center;
}
.lke-titl i {
  color: #2890f4;
  padding-right: 5px;
  font-size: 20px;
}
.lke-mid {
  border: 1px solid #ccc;
  margin-bottom: 20px;
}
.lke-mid-top {
  padding: 10px 20px;
  font-size: 18px;
  color: #409eff;
  display: flex;
  align-items: center;
  font-weight: bold;
  border-bottom: 1px solid #ccc;
  background: #f7f7f7;
}
.lke-mid-top > i {
  font-size: 30px;
  padding-right: 20px;
}
.lke-mid-fot {
  padding: 20px 50px 20px 20px;
  line-height: 2;
}
.lke-tab1in-top > i {
  font-size: 18px;
  color: #409eff;
}
.lke-tab1in-fot {
  display: flex;
  align-items: center;
  padding: 10px 0;
  padding-left: 90px;
}
.lke-tab1in-fot > span {
  font-size: 14px;
  color: #888888;
  padding-right: 50px;
}
.lke-tab1in-fot > div {
  flex: 1;
}
.lke-tab {
  display: flex;
}
.lke-tab-l {
  width: calc(70%);
  color: #666666;
  padding-right: 20px;
  padding-bottom: 30px;
}
.lke-tab-l p {
  font-size: 16px;
  line-height: 2;
  text-indent: 30px !important;
}
.lke-tab-l span {
  line-height: 2;
  font-family: 仿宋_GB2312;
  font-size: 12pt;
  font-weight: bolder;
}
.lke-tab-r {
  text-align: center;
}
.lke-tab-r > img {
  width: 80%;
  padding: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/page/grzx/zssq/zssq.vue